import {
	Component,
	EventEmitter,
	HostBinding,
	Input,
	OnInit,
	Output
}                        from '@angular/core';
import { BaseComponent } from '@app/core/bases/base-component/base.component';
import {
	AllowedDetailsTabEnum,
	ITabItem
}                        from '@app/core/interfaces/common.interfaces';


@Component( {
	selector: 'app-tabs[tabItemsData]',
	templateUrl: './tabs.component.html',
	styleUrls: [ './tabs.component.scss' ]
} )
export class TabsComponent extends BaseComponent implements OnInit {

	tabItemsDataList: ITabItem[] = [];

	singleTabI18nTitlePath: string;

	@Input() activeTab: AllowedDetailsTabEnum;

	@Input() renderTabContents = true;

	@Output() tabSwitched: EventEmitter<AllowedDetailsTabEnum> = new EventEmitter<AllowedDetailsTabEnum>();

	@Input( 'tabItemsData' )
	set tabItemsData( tabItemsData: ITabItem[] ) {
		this.tabItemsDataList = tabItemsData?.map( ( tabItem: ITabItem, idx: number ) => {
			tabItem.tabId = idx + 1;
			return tabItem;
		} );

		this.singleTabI18nTitlePath = tabItemsData?.length === 1
																	? tabItemsData[ 0 ]?.i18nTitlePath
																	: null;
	}

	@Input() baseClass: string;

	@Input() tabNavWrapperClass: string;

	@Input() tabContentWrapperClass: string;

	@HostBinding( 'class' ) hostClass: string;

	constructor() {
		super();
	}

	ngOnInit(): void {
		this.hostClass = this.baseClass ? this.baseClass : '';
		this.tabNavWrapperClass = this.tabNavWrapperClass ? this.tabNavWrapperClass : '';
		this.tabContentWrapperClass = this.tabContentWrapperClass ? this.tabContentWrapperClass : '';

		// initial tab activation with fallbacks:
		// 1. provided activeTab if enabled
		const selectedActiveTabIsEnabled = this.tabItemsDataList.some( ( tabItem: ITabItem ) =>
			tabItem?.tabIdentifier === this.activeTab && !tabItem?.disabled
		);

		// 2. first enabled tab
		// 3. when no tab is enabled, first tab of tabItemsDataList
		if ( !selectedActiveTabIsEnabled ) {
			const firstEnabledTab = this.tabItemsDataList.find( ( tabItem: ITabItem ) =>
				!tabItem?.disabled
			);
			this.activeTab = firstEnabledTab
											 ? firstEnabledTab?.tabIdentifier
											 : this.tabItemsDataList[ 0 ]?.tabIdentifier;
		}
	}

	getIndexOfActiveTab(): number {
		return this.tabItemsDataList.findIndex( tab => tab?.tabIdentifier === this.activeTab );
	}
}
